import 'babel-polyfill'
import '!vue-style!css!normalize-css/normalize.css'
import '!vue-style!css!bootstrap/dist/css/bootstrap.css'
import '!vue-style!css!todc-bootstrap/dist/css/todc-bootstrap.min.css'
import '!css!./assets/quill.snow.css'
import '!vue-style!css!./common.css'

import biu from 'biu.js' // TODO debug 企业微信登录验证 测试版可注释关闭
import '!vue-style!css!biu.js/dist/biu.css'

import Vue from 'vue'
import Cookie from 'js-cookie'
import utils from './libs/utils' // TODO debug 企业微信登录验证 测试版可注释关闭
import Resource from 'vue-resource'
import Sortable from './directives/v-sortable'

import App from './App'
import Router from 'vue-router'

Vue.use(Router)
Vue.use(Resource)
Vue.use(Sortable)

// TODO debug 企业微信登录验证 测试版可注释关闭
Vue.http.interceptors.push(() => {
  return {
    request (request) {
      let token = Cookie.get('xmenToken')

      if (token) {
        request.headers['Xmen-Token'] = token
      }

      return request
    },
    response (response) {
      let msg
      if (!response.ok) {
        switch (response.status) {
          case 401:
            Cookie.remove('xmenToken')
            utils.login()
            break
          case 403:
            msg = '您没有权限执行此操作'
            break
          default:
            msg = typeof response.data === 'object' ? JSON.stringify(response.data) : response.data
        }
        biu(msg, {
          type: 'danger',
          timeout: 2000
        })
      }
      if (response.ok && response.request.method !== 'GET') {
        biu('success', {
          type: 'success',
          timeout: 1500
        })
      }
      return response
    }
  }
})

const router = new Router({
  saveScrollPosition: true,
  history: true
})

router.map({
  '/tags': {
    component: require('./views/Tags')
  },
  '/wechat': {
    component: require('./components/Hello')
  },
  '/login': {
    component: require('./views/Login')
  },
  '/arrange': {
    component: require('./views/Arrange')
  },
  '/product/trip': {
    component: require('./views/trip/List')
  },
  '/routes': {
    component: require('./views/route/List')
  },
  '/routes/trashed': {
    component: require('./views/route/Trashed')
  },
  '/routes/carousel': {
    component: require('./views/route/Carousel')
  },
  '/route/:id': {
    component: require('./views/route/ItemWraper'),
    subRoutes: {
      '/basic': {
        component: require('./views/route/Basic')
      },
      '/assembling': {
        component: require('./views/route/Assembling')
      },
      '/itinerary': {
        component: require('./views/route/Itinerary')
      },
      '/focus': {
        component: require('./views/route/Focus')
      },
      '/notice': {
        component: require('./views/route/Notice')
      },
      '/images': {
        component: require('./views/route/Images')
      }
    }
  },
  '/givers': {
    component: require('./views/giver/List')
  },
  '/adminer': {
    component: require('./views/adminer/List')
  },
  '/adminer/:id': {
    component: require('./views/adminer/Edit')
  },
  '/giver': {
    component: require('./views/giver/Item')
  },
  '/giver/:id': {
    component: require('./views/giver/Item')
  },
  '/train/:status': {
    component: require('./views/train/Train')
  },
  '/try/:status': {
    component: require('./views/try/Try')
  },
  '/feedback': {
    component: require('./views/feedback/List.vue')
  },
  '/feedback/member': {
    component: require('./views/feedback/MemberList.vue')
  },
  '/feedback/trip/member': {
    component: require('./views/feedback/TripMemberList.vue')
  },
  '/feedback/:id': {
    component: require('./views/feedback/Item.vue')
  }
})
.beforeEach(function (transition) {
  if (!Cookie.get('xmenToken')) {
    utils.login()
    transition.next()
  } else {
    transition.next()
  }
})
.redirect({
  '*': '/routes'
})

Vue.filter('constellation', function (input) {
  var date = new Date(input)
  var m = date.getMonth() + 1
  var d = date.getDate()
  return '魔羯水瓶双鱼牡羊金牛双子巨蟹狮子处女天秤天蝎射手魔羯'
    .substr(m * 2 - (d < '102223444433'.charAt(m - 1) - -19) * 2, 2)
})

Vue.filter('toFixed', function (input, round) {
  const number = +input
  if (Number.isNaN(number)) {
    return input
  }

  return number.toFixed(round)
})

router.start(App, '#app')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/